// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../var/task/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guestbox[data-v-7f1a32f3]{margin:0 auto;line-height:46px;text-align:left;font-size:15px;color:#676767}.guest-info[data-v-7f1a32f3]{font-size:.77rem;margin-top:-25px;display:block}.gb-td[data-v-7f1a32f3]{padding:8px 12px}.btn[data-v-7f1a32f3]{width:48px;height:48px;line-height:1;border-radius:50%;font-size:30px;padding:4px}.label[data-v-7f1a32f3]{white-space:nowrap}", ""]);
// Exports
module.exports = exports;
